import React from 'react';
import { Route, Routes, NavLink } from 'react-router-dom';

import PropTypes from 'prop-types';

import ClientLayout from '@/components/ClientLayout';
import Card from '@/components/common/Card';
import Home from '@/components/MarketplacePage/Home';
import Service from '@/components/MarketplacePage/Service';
import classes from '@/components/MarketplacePage/style.module.scss';
import installedImage from '@/images/icons/installed.svg';
import squaresImage from '@/images/icons/squares.svg';

const MarketplacePageComponent = ({ intl }) => (
  <ClientLayout>
    <div className={classes.marketplace}>
      <Card className={classes.card}>
        <div className={classes.menu}>
          <ul>
            <li>
              <NavLink to="/marketplace" end className={({ isActive }) => (isActive ? classes.isActive : '')}>
                <img src={squaresImage} alt={intl.formatMessage({ id: 'GALLERY' })} />
                {intl.formatMessage({ id: 'GALLERY' })}
              </NavLink>
            </li>
            <li>
              <NavLink to="/marketplace/enabled" end className={({ isActive }) => (isActive ? classes.isActive : '')}>
                <img src={installedImage} alt={intl.formatMessage({ id: 'INSTALLED' })} />
                {intl.formatMessage({ id: 'INSTALLED' })}
              </NavLink>
            </li>
          </ul>
        </div>
        <div className={classes.content}>
          <Routes>
            <Route path="enabled" element={<Home filterEnabled />} />
            <Route path=":service" element={<Service />} />
            <Route index element={<Home />} />
          </Routes>
        </div>
      </Card>
    </div>
  </ClientLayout>
);

MarketplacePageComponent.propTypes = {
  intl: PropTypes.object.isRequired,
};

export default MarketplacePageComponent;
